import React, { useState, useRef, useEffect } from "react";
import JoditEditor from "jodit-react";
import textFile from "./script_text.txt";
import parse from "html-react-parser";
import ScriptSearch from "components/ScriptSearch";
import { Button, CircularProgress } from "@mui/material";
import { Edit, Save } from "@material-ui/icons";
import axios from "config/axios";
import "./script.css";
import { toast } from "react-toastify";
import { handleAxiosResponseError } from "utils/handleResponseError";
import useUserStore from "store/user";
import ScriptAccordion from "./ScriptAccordion";
import { toTitleCase } from "utils/TitleCase";

// import { useHistory } from "react-router-dom";

export default function Script2Editor() {
  const editor = useRef(null);
  const [isEdit, setIsEdit] = useState(false);
  const [content, setContent] = useState("");
  const [newContent, setNewContent] = useState("");
  const [search, setSearch] = useState("");
  const [saveClick, setSaveClick] = useState(false);
  const { user, updateScript } = useUserStore();
  const [tableOfContent, setTableOfContent] = useState([]);
  const tableRef = useRef();

  // const history = useHistory();

  const handleEditorChange = (Content) => {
    setContent(Content);
    setNewContent(Content);
  };

  useEffect(() => {
    if (user?.document && user?.role !== "admin") {
      setContent(user.document);
      setNewContent(user.document);
    } else
      fetch(textFile)
        .then((r) => r.text())
        .then((text) => {
          setContent(text);
          setNewContent(text);
        });
  }, [user]);

  const addHtml = (text, inputValue) => {
    // let inputValue = input.value;
    let updateText = text;
    if (inputValue) {
      let textToSearch = inputValue.replace(/[.*+?^${}()|\\]/g, "\\$&");

      let pattern = new RegExp(`${textToSearch}`, "gi");

      updateText = text.replace(
        pattern,
        (match) => `<span className="text-highlight">${match}</span>`
      );
    } else {
      updateText = text;
    }

    return updateText;
  };

  useEffect(() => {
    setNewContent(content);
    if (search.length > 2) {
      setNewContent(addHtml(content, search));
    }
  }, [search, content]);

  const handleSave = () => {
    const data = { document: content };
    setSaveClick(true);

    axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/script-document2`,
        data
      )
      .then(({ data }) => {
        setSaveClick(false);
        toast.success(data.message);
        updateScript(content);
        setIsEdit(!isEdit);
      })
      .catch((err) => {
        setSaveClick(false);
        console.log(handleAxiosResponseError(err));
        toast.error(handleAxiosResponseError(err));
      });
  };

  useEffect(() => {
    if (tableRef?.current) {
      const length = tableRef?.current?.childNodes?.length;
      const row =
        tableRef?.current?.childNodes[length - 1]?.childNodes[0]?.childNodes;

      const arr = [];
      for (let index = 1; index < row?.length; index++) {
        const element = row[index];
        // console.log(element);
        // arr.push(element.cells[0].innerText);
        arr.push(toTitleCase(element.cells[0].innerText));
      }

      setTableOfContent(arr);
    }
  }, [newContent, user, tableRef]);

  const scrollToRow = (position) => {
    if (tableRef?.current) {
      const length = tableRef?.current?.childNodes?.length;

      const row =
        tableRef?.current?.childNodes[length - 1]?.childNodes[0]?.childNodes[
          position
        ];
      row.scrollIntoView();
    }
  };

  return (
    <div>
      <div className="script_search_section">
        <div></div>
        {/* <IconButton onClick={() => history.push("/admin/scripts")}>
          <ArrowBack />
        </IconButton> */}
        <div className="script_action">
          {isEdit ? (
            <Button
              className="pl-4 pr-4 mr-2 btn save_btn"
              type="button"
              onClick={handleSave}
            >
              {saveClick ? (
                <CircularProgress color="inherit" />
              ) : (
                <>
                  Save
                  <Save className="ml-1" fontSize="small" />
                </>
              )}
            </Button>
          ) : (
            <>
              <Button
                className={`pl-4 pr-4 mr-2 btn save_btn`}
                type="button"
                onClick={() => setIsEdit(!isEdit)}
              >
                Edit
                <Edit className="ml-1" fontSize="small" />
              </Button>
              <div className="script_search">
                <ScriptSearch search={search} setSearch={setSearch} />
              </div>
            </>
          )}
        </div>
      </div>
      {isEdit ? (
        <></>
      ) : (
        <ScriptAccordion
          scrollToRow={scrollToRow}
          tableOfContent={tableOfContent}
        />
      )}
      <div className="editor_section">
        {isEdit ? (
          <JoditEditor
            ref={editor}
            value={content}
            onChange={handleEditorChange}
          />
        ) : (
          <>
            <div className="notes_section" ref={tableRef}>
              <div className="mb-4">
                <span className="font-weight-bold">
                  Disclaimer of Liability.
                </span>{" "}
                You are responsible for the correct usage of District Policies,
                Procedures, Regulations, and Supervisoral guidance. The scripts
                below are in alignment with best practices; however, situations
                vary by environment and circumstance. Scripts are provided to
                guide and support professional educators in difficult situations
                as memory joggers and not as a substitute for professional
                judgment or District and/or Federal practices and laws.{" "}
                <span className="font-weight-bold">
                  {" "}
                  By use, you agree that neither Principally nor any of our
                  service providers shall be liable for any loss or damages
                  (whether direct, indirect, special, consequential, or
                  otherwise) including economic, property, personal, or other
                  loss or injury, whether caused by us, the hardware or
                  software, or a system-wide failure, arising or resulting from
                  the use, or maintenance of the scripts, software, or other
                  items necessary to access and/or operate Principally.
                </span>
              </div>
              {parse(newContent)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
